import {actions} from "../actions/actionTypes";
import {getStorage} from "../actions";
import {keyTokenLogin, userLogin, userNameLogin} from "../util/constants";

export const initialState = {
    showLoading:false,
    userLogged: getStorage(userLogin),
    userNameLogged: getStorage(userNameLogin),
    tokenUserLogged : getStorage(keyTokenLogin),
}

export default (state = initialState, action) => {
    switch (action.type){
        case actions.SHOW_LOADING:
            return {
                ...state,
                showLoading : action.visible
            };
        case actions.SET_USER:
            return {
                ...state,
                userLogged : action.userLogged,
                userNameLogged : action.userNameLogged,
                tokenUserLogged : action.tokenUserLogged
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redurcers/sessionReducer.js